import styled from 'styled-components';

import theme from '../../../assets/theme';

const BottomDrawerDragHandle = ({ onClose }: { onClose: () => void }) => {
  return (
    <DragHandleContainer>
      <Handle role="button" onClick={onClose} onDragStart={onClose} />
    </DragHandleContainer>
  );
};

export default BottomDrawerDragHandle;

const Handle = styled.div`
  width: 20%;
  height: 4px;
  background: ${theme.colors.grey};
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  &:hover {
    background: ${theme.colors.greyDark};
  }
`;

const DragHandleContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  width: 100%;
`;
